import React from "react";
import PropTypes from "prop-types";
import styles from "./RadioButton.module.css";
import classNames from "classnames";

/**
 * Interactive component. A radio button that allows a user to select an option.
 */
export function RadioButton({ isSelected, setCurrentlySelected, value }) {
  return (
    <div
      className={styles.container}
      onClick={() => setCurrentlySelected(value)}
    >
      <label htmlFor={value} className={styles.options}>{value}</label>
      <label>
        <input
          type="radio"
          value={value}
          name={value}
          defaultChecked={isSelected}
          hidden
        />
        <div className={styles["radio-container"]}>
          <span
            className={classNames(styles.radio, {
              [styles.checked]: isSelected,
            })}
          />
        </div>
      </label>
    </div>
  );
}

RadioButton.propTypes = {
  /**
   * Boolean that determines if the option is selected.
   */
  isSelected: PropTypes.bool,
  /**
   * Function that sets the value of the currently selected option.
   * The parent component should perform a check that the current value is not equivalent to isSelected within this function.
   */
  setCurrentlySelected: PropTypes.func,
  /**
   * The option value. Serves as the label.
   */
  value: PropTypes.string,
};
